import { ShoppingBasket, Croissant, Beer, Pill, Wine, TrainFront } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

const items = [
  { Icon: ShoppingBasket, key: "coviran", t: "Coviran (Serro Supermercados)", d: "Supermercado local completo. Frescos, congelados, bebidas e bazar.", dist: "~80 metros", gold: true },
  { Icon: Croissant, key: "padaria", t: "Padaria Local", d: "Pão fresco de manhã e à tarde. Perfeita para o pequeno-almoço e lanche.", dist: "~150 metros" },
  { Icon: Beer, key: "barclube", t: "Bar-Sede FC Mexilhoeira Grande", d: "Pratos do dia · ★ 4.6 Google. O favorito dos locais.", dist: "~200 metros" },
  { Icon: Pill, key: "farmacia", t: "Farmácia de Mexilhoeira", d: "Para emergências médicas: Hospital Portimão 282 450 300 (24h).", dist: "~300 metros" },
  { Icon: Wine, key: "adega", t: "Adega Vila Lisa", d: "Ícone gastronómico desde 1981. Reserva obrigatória: 282 968 478.", dist: "~400 metros" },
  { Icon: TrainFront, key: "cp", t: "Estação CP Mexilhoeira", d: "Linha Algarve: Lagos ↔ Faro. Bilhetes em cp.pt ou direto no comboio.", dist: "~500 metros" },
];

export default function Vizinhanca() {
  const { t } = useT();
  return (
    <section id="vizinhanca" className="py-20 md:py-28 bg-paper" data-testid="vizinhanca-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal max-w-2xl">
          <p className="section-label">{t.neighborhood.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0e1a3f] leading-tight">
            {t.neighborhood.title1}
            <br />
            <em className="text-[#1e3a8a]">{t.neighborhood.title2}</em>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {items.map(({ Icon, key, t: title, d, dist, gold }) => (
            <article
              key={key}
              className="reveal card-lift bg-white p-6 rounded-2xl ring-1 ring-[#0e1a3f]/10 flex flex-col"
              data-testid={`viz-${key}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#d6e2f5] text-[#1e3a8a] flex items-center justify-center flex-shrink-0">
                  <Icon size={22} strokeWidth={1.8} />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg text-[#0e1a3f] leading-tight">{title}</h3>
                  <p className="mt-2 text-sm text-[#0e1a3f]/70 leading-relaxed">{d}</p>
                </div>
              </div>
              <p
                className={`mt-5 inline-flex items-center gap-1.5 text-[11px] px-3 py-1.5 rounded-full self-start font-semibold tracking-wider ${
                  gold ? "bg-[#c89033] text-white" : "bg-[#0e1a3f] text-[#faf6ee]"
                }`}
              >
                ⚡ {dist}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
